import { useCallback, useEffect } from "react";

import useService from "../../../../hooks/useService";
import ApiRequestErrorHandler from "../../../global/ApiRequestErrorHandler";
import { useContractStore } from "../store/contractStore";

export default function useContractsData(entityId, enabled = true) {
  const contractsRepository = useService("repositories/contracts-repository");
  const {
    data,
    setData,
    loading,
    resLimit,
    currentPage,
    setLoading,
    setResultCount,
  } = useContractStore();

  const fetchContractsData = useCallback(async () => {
    if (!enabled) {
      setData([]);
      setResultCount(0);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const queryParams = {};

      if (resLimit && currentPage) {
        queryParams.limit = resLimit;
        queryParams.offset = (Number(currentPage) - 1) * resLimit || 0;
      }

      if (entityId) {
        queryParams.entity = entityId;
      }

      const response = await contractsRepository.query(queryParams);
      const count = await contractsRepository.getTotalCount();
      setData(response ?? []);
      setResultCount(count);
    } catch (error) {
      ApiRequestErrorHandler(error);
    } finally {
      setLoading(false);
    }
  }, [
    contractsRepository,
    currentPage,
    enabled,
    entityId,
    resLimit,
    setData,
    setLoading,
    setResultCount,
  ]);

  useEffect(() => {
    fetchContractsData();
  }, [fetchContractsData]);

  return {
    data,
    fetchContractsData,
    loading,
  };
}
